export const QUOTATION_DEFAULT_VALUES = {
  client_id: '',
  client: {
    name: '',
    street: '',
    postal_code: '',
    city: '',
    country_id: null,
  },
  type: 'quotation',
  number: '',
  document_number: '',
  reference: '',
  subject: '',
  expires_at: '',
  issued_at: new Date(),
  invoice_expires_after: 30,
  subtotal: 0,
  vat: 0,
  total: 0,
  created_at: new Date().toISOString(),
  updated_at: '',
  lines: [{ label: '', description: null, quantity: 1, price: 0, vat_code_id: null, vat_code: null }],
}
